<template>
    <page-wrap class="zyzx">
        <el-card style="width: 100%;">
            <h2 class="xpqd">主页装修</h2>
            <div class="decoration">
                <el-row>
                    <el-col :span="20" style="font-size: 15px;padding: 5px 0">Banner轮播图</el-col>
                    <el-col :span="4"style="font-size: 15px;padding:0px 0px 10px"> <el-button v-show="false" type="success" @click="shopDesign()" class="tijiao_design" size="small">提 交</el-button></el-col>
                </el-row>
                <el-row>
                    <el-col :span="7">
                        <el-card class="box-card">
                            <div>
                                <el-upload class="avatar-uploader"
                                           action="/index.php/page/Decoration/upload"
                                           name="image"
                                           :show-file-list="false"
                                           :on-success="handleAvatarSuccess1">
                                    <img v-if="lbt1" :src="lbt1" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    <div slot="tip" class="el-upload__tip" v-show="!lbt1">请上传1200*400像素的图片</div>
                                    <div class="a_a" style="width: 287px;" v-show="lbt1">
                                        <span>更换</span>
                                        <span>|</span>
                                        <span @click.stop="delBanner(1)">删除</span>
                                        <span>|</span>
                                        <span @click.stop="binding(1)" v-show="g_id1==''">绑定</span>
                                        <span @click.stop="binding(1)" v-show="g_id1!=''">商品ID：{{this.g_id1}}</span>
                                    </div>
                                </el-upload>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8" :offset="1">
                        <el-card class="box-card" >
                            <div>
                                <el-upload class="avatar-uploader"
                                           action="/index.php/page/Decoration/upload"
                                           name="image"
                                           :show-file-list="false"
                                           :on-success="handleAvatarSuccess2">
                                    <img v-if="lbt2" :src="lbt2" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    <div slot="tip" class="el-upload__tip" v-show="!lbt2">请上传1200*400像素的图片</div>
                                    <div class="a_a" style="width: 336px;" v-show="lbt2">
                                        <span>更换</span>
                                        <span>|</span>
                                        <span @click.stop="delBanner(2)">删除</span>
                                        <span>|</span>
                                        <span @click.stop="binding(2)" v-show="g_id2==''">绑定</span>
                                        <span @click.stop="binding(2)" v-show="g_id2!=''">商品ID：{{g_id2}}</span>
                                    </div>
                                </el-upload>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="7" :offset="1">
                        <el-card class="box-card" >

                            <div>
                                <el-upload class="avatar-uploader"
                                           action="/index.php/page/Decoration/upload"
                                           name="image"
                                           :show-file-list="false"
                                           :on-success="handleAvatarSuccess3">
                                    <img v-if="lbt3" :src="lbt3" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    <div slot="tip" class="el-upload__tip" v-show="!lbt3">请上传1200*400像素的图片</div>
                                    <div class="a_a" style="width: 287px;" v-show="lbt3">
                                        <span>更换</span>
                                        <span>|</span>
                                        <span @click.stop="delBanner(3)">删除</span>
                                        <span>|</span>
                                        <span @click.stop="binding(3)" v-show="g_id3==''">绑定</span>
                                        <span @click.stop="binding(3)" v-show="g_id3!=''">商品ID：{{g_id3}}</span>
                                    </div>
                                </el-upload>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row style="">
                        <el-row>
                            <el-col style="font-size: 15px;padding: 10px 0">热销产品</el-col>
                        </el-row>
                        <div style="margin: 0 0 15px 0;">
                            <div v-for="(tag_item,key) in tag" style="display:inline;margin-left: 20px">
                                <span @click="changeTag(key,tag_item)" style="cursor: pointer;"
                                      v-bind:class="{ active: isActive[key] }">{{tag_item.bt_name}}</span>
                                <i class="el-icon-close" @click="delTag(tag_item)" style="cursor: pointer;"></i>
                            </div>
                            <div style="display:inline;margin-left: 20px">
                                <span @click="handleAddIf=true" style="cursor: pointer;"><i class="el-icon-plus"></i> 添加标签</span>
                            </div>
                        </div>
                        <div>
                            <hr>
                        </div>
                        <div style="display: flex;display:-webkit-flex;margin: 20px 0 0 0;">
                            <div v-for="(good_item,index) in currentGoods" style="margin-left: 20px;position: relative">
                                <template v-if="good_item != null">
                                    <img :src="good_item.g_image" width="200" height="200">
                                    <div class="a_a">
                                        <span @click="updateGoods(good_item,index)">更换</span>
                                        <span>|</span>
                                        <span @click="delGoods(good_item,index)">删除</span>
                                    </div>
                                </template>
                            </div>
                            <div class="addGoodsDiv" v-for="n in leftGoodsNum" @click="addGoods()">
                                <h1 class="el-icon-plus" style="font-size: 50px;margin: 75px 0px 0 75px;"></h1>
                            </div>
                        </div>
                </el-row>
                <el-row style="">
                <div style="margin: 25px 0 15px 0;">
                  <hr>
                </div>
                <h2>百科词条</h2>
                <div style="margin: 20px 0 0 0;">
                  <div class="select-dx">
                    <el-form ref="form"  label-width="200px">
                      <el-form-item label="词条:" required>
                        <el-input v-model="baidu_entry" class="input-item"></el-input>
                        <el-popover
                          placement="right"
                          :offset="150"
                          width="300"
                          trigger="hover"
                          content=''>
                          <div>爱采购不提供为会员创建百科词条的服务，会员可通过官方通道自行创建</div>
                          <a href="https://baike.baidu.com/enterprise/create" target="_blank">https://baike.baidu.com/enterprise/create</a>
                          <el-button type="text" style="margin-left: 10px;" slot="reference" icon="el-icon-info"></el-button>
                        </el-popover>
                      </el-form-item>
                      <el-form-item class="submit_but">
                        <el-button v-show="false" type="primary"  @click="onEntry()" size="small">保存</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>

              </el-row>



                <el-row style="">
                    <div style="margin: 25px 0 15px 0;">
                        <hr>
                    </div>
                    <h2>选择模板</h2>
                    <div style="display: flex;display:-webkit-flex;margin: 20px 0 0 0;">
                        <div class="template-title" v-show="this.t_name">当前模板： {{t_name}}</div>
                        <div class="select-dx">
                            <el-form prop="region">
                                <el-form-item  required>
                                    <el-select v-model="t_id" placeholder="请选择" clearable  @change="renewalImgName">
                                        <el-option
                                                v-for="item in temp"
                                                :label="item.t_name"
                                                :value="item.t_id"
                                                :key="item.t_id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="images-zs">
                        <div class="block" v-show="this.src_img" style="width: 200px;">
                            <img style="width:140px;height: 170px" :src="src_img">
                        </div>
                    </div>
                    <div class="button-an">
                        <el-button type="primary" @click="handleUpdatpId(t_id)">确定</el-button>
                        <el-button @click="resetForm('ruleForm')">取消</el-button>
                    </div>
                </el-row>
            </div>
            <add v-if="handleAddIf" @callback="callbackAdd"/>
            <Goods :handle="showGoods" @close="showGoods=false" @select="selectGoods" id="xzkh1"/>
            <GoodsBin :handle="binGoods" @close="binGoods=false" @select="onGoods" id="xzkh2"/>
        </el-card>
    </page-wrap>
</template>

<style>
    .content{
        overflow-x: hidden;
         overflow-y: auto;
    }

    .decoration .addGoodsDiv {
        width: 200px;
        height: 200px;
        background-color: rgb(243, 243, 243);
        margin-left: 20px;
        cursor: pointer;
    }

    .decoration .a_a {
        position: absolute;
        width: 200px;
        text-align: center;
        bottom: 0;
        color: #ffff;
        background: rgba(0, 0, 0, 0.4);
        cursor: pointer;
        padding: 6px 0 6px 0;
    }

    .decoration .active {
        color: #00a2d4;
    }

    .decoration .box-card {
        width: 100%;
        height: 200px;
    }

    .decoration .box-card1 {
        width: 100%;
        height: 400px;
    }

    .decoration .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .decoration .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .decoration .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .decoration .avatar {
        width: 100%;
        display: block;
    }
    .decoration .template-title{
        width: 40%;
    }
    .decoration .images-zs{
        width: 200px;
        margin-left: 5%;
    }
    .decoration .button-an{
        text-align: center;
    }
    .decoration .button-an button{
        width: 100px;
        height: 30px;
        padding: 5px 20px;
    }
  .button_show{
    text-align: center;
  }
  .input-item{
    width: 400px;
  }
    .submit_but  button{
      width: 100px;
      height: 30px;
      margin-left: 5px;
    }
  .tijiao_design{
    width: 100px;
    height: 30px;
    padding: 5px 20px;
  }
</style>

<script>
    import Add from "./Add.vue";
    import Edit from "./Edit.vue";
    import Goods from "./../../../components/dialog/Goods.vue";
    import GoodsBin from "./../../../components/dialog/GoodsBin.vue";
    import {mapState, mapMutations, mapGetters} from "vuex";

    export default {
        components: {
            Add,
            Edit,
            Goods,
            GoodsBin,
        },
        data() {
            return {

                src_img: '',
                t_name:'',
                handleAddIf: false,
                handleEditIf: false,
                lbt1: '',
                lbt2: '',
                lbt3: '',
                tag: [],
                temp:[],
                t_id:'',
                currentGoods: [],
                currentTagId: 0,
                isActive: [],
                showGoods: false,
                updateGoodsIndex: 0,
                updateGoodsRow: '',
                //2020-4-14
                binGoods:false,
                g_id:'',
                g_id1:'',
                g_id2:'',
                g_id3:'',
                goodNmber:'',
                g_name:'',
                baidu_entry:'',
                design:{
                    b_id:'',
                    g_id:'',
                },
                b_id:'',

            };
        },
        computed: {
            ...mapGetters("navTabs", ["tabTableHeight"]),
            leftGoodsNum: function () {
                return 4 - this.currentGoods.length >=0?4 - this.currentGoods.length:0;
            }
        },
        mounted() {
            this.onSubmit();
            this.renewalImgName
            this.goodsId();
        },
        watch: {},
        methods: {
            selectGoods(row) {
                if (this.updateGoodsRow) {
                    //更换
                    let that = this;
                    this.$confirm(
                        "确定更换此商品为【" + row.g_name + "】吗?",
                        "提示",
                        {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }
                    ).then(() => {
                        this.$ajax
                            .post("page/Decoration/updateGoods", {
                                g_id: row.g_id,
                                bt_id: that.currentTagId,
                                old_g_id: that.updateGoodsRow.g_id
                            })
                            .then(function (res) {
                                if (res.data.error === 0) {
                                    that.$message({
                                        type: "success",
                                        message: "更新成功!"
                                    });
                                    let a1 = row.g_id;
                                    let a2 = row.g_name;
                                    let a3 = row.g_image;
                                    that.$set(that.currentGoods[that.updateGoodsIndex], 'g_image', a3)
                                    that.$set(that.currentGoods[that.updateGoodsIndex], 'g_id', a1)
                                    that.$set(that.currentGoods[that.updateGoodsIndex], 'g_name', a2)
                                } else {
                                    that.$message(res.data.message);
                                }
                            });
                    }).catch(() => {
                        that.$message({
                            type: "info",
                            message: "已取消更新"
                        });
                    });
                } else {
                    //添加
                    let that = this;
                    this.$confirm(
                        "确定添加此商品【" + row.g_name + "】吗?",
                        "提示",
                        {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning"
                        }
                    ).then(() => {
                        this.$ajax
                            .post("page/Decoration/addGoods", {g_id: row.g_id, bt_id: that.currentTagId})
                            .then(function (res) {
                                if (res.data.error === 0) {
                                    that.$message({
                                        type: "success",
                                        message: "添加成功!"
                                    });
                                    that.currentGoods.push(row)
                                } else {
                                    that.$message(res.data.message);
                                }
                            });
                    }).catch(() => {
                        that.$message({
                            type: "info",
                            message: "已取消添加"
                        });
                    });
                }
            },
            addGoods() {
                this.updateGoodsRow = ''
                this.updateGoodsIndex = ''
                this.showGoods = true
            },
            updateGoods(row, index) {
                this.updateGoodsRow = row
                this.updateGoodsIndex = index
                this.showGoods = true
            },
            delGoods(row, index) {
                let that = this;
                this.$confirm(
                    "确定删除此商品【" + row.g_name + "】吗?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                ).then(() => {
                    this.$ajax
                        .post("page/Decoration/delGoods", {g_id: row.g_id, bt_id: that.currentTagId})
                        .then(function (res) {
                            if (res.data.error === 0) {
                                that.$message({
                                    type: "success",
                                    message: "删除成功!"
                                });
                                that.currentGoods.splice(index, 1);
                            } else {
                                that.$message(res.data.message);
                            }
                        });
                }).catch(() => {
                    that.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
            },
            changeTag(key, row) {
                this.currentGoods = row.goods
                this.currentTagId = row.bt_id
                this.isActive = []
                this.isActive[key] = true
            },
            delTag(row) {
                let that = this;
                this.$confirm(
                    "确定删除此标签【" + row.bt_name + "】吗?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                ).then(() => {
                    this.$ajax
                        .post("page/Decoration/delete", {id: row.bt_id})
                        .then(function (res) {
                            if (res.data.error === 0) {
                                that.$message({
                                    type: "success",
                                    message: "删除成功!"
                                });
                                that.onSubmit();
                            } else {
                                that.$message(res.data.message);
                            }
                        });
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
            },
            onSubmit() {
                let that = this;
                this.$ajax
                    .post("/page/Decoration/index").then(function (res) {

                    if (res.data.error === 0) {
                        that.lbt1 = res.data.data.lbt.home_display_1;
                        that.design.url = res.data.data.lbt.home_display_1;
                        that.lbt2 = res.data.data.lbt.home_display_2;
                        that.lbt3 = res.data.data.lbt.home_display_3;
                        that.tag = res.data.data.tag
                        that.temp =res.data.data.temp
                        that.t_id =  res.data.data.lbt.t_id;
                        that.b_id = res.data.data.lbt.b_id;
                        that.renewalImgName(that.t_id)
                        let row = that.tag[0]
                        that.currentGoods = row.goods
                        that.currentTagId = row.bt_id
                        that.isActive = []
                        that.isActive[0] = true


                    }
                })
                    .catch(function (err) {
                        that.loading = false;
                    });
            },
            handleAvatarSuccess1(response, file) {
                if (response.error === 0) {
                    this.lbt1 = response.data
                    this.updateLbt(1, response.data)
                } else {
                    this.$message.error(response.message)
                }
            },
            handleAvatarSuccess2(response, file) {
                if (response.error === 0) {
                    this.lbt2 = response.data
                    this.updateLbt(2, response.data)
                } else {
                    this.$message.error(response.message)
                }
            },
            handleAvatarSuccess3(response, file) {
                if (response.error === 0) {
                    this.lbt3 = response.data

                    this.updateLbt(3, response.data)
                } else {
                    this.$message.error(response.message)
                }
            },
            delBanner(index) {

                let that = this;
                this.$confirm(
                    "确定删除此轮播图吗?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                ).then(() => {
                    this.$ajax
                        .post("page/Decoration/deleteBanner", {id: index})
                        .then(function (res) {
                            if (res.data.error === 0) {
                                that.$message({
                                    type: "success",
                                    message: "删除成功!"
                                });
                                that.onSubmit();
                            } else {
                                that.$message(res.data.message);
                            }
                        });
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
            },
            updateLbt(id, src) {
                let that = this;
                this.$ajax
                    .post("/page/Decoration/updateLbt", {
                        id: id,
                        src: src
                    })
                    .then(function (res) {
                        if (res.data.error === 0) {
                            that.$message({
                                type: "success",
                                message: "更新轮播图成功!"
                            });
                        }
                    })
                    .catch(function (err) {
                        that.$message("网络错误！请联系管理员");
                        that.loading = false;
                    });
            },
            callbackAdd(data) {
                this.handleAddIf = false;
                if (data) {
                    this.$message({
                        type: "success",
                        message: "添加成功!"
                    });
                    this.onSubmit();
                }
            },
            callbackEdit(data) {
                this.handleEditIf = false;
                if (data) {
                    this.$message({
                        type: "success",
                        message: "编辑成功!"
                    });
                    this.onSubmit();
                }
            },
            renewalImgName(t_id){
                if (!t_id){
                    this.src_img = "/static/img/mrmb.a01ba7e.jpg"
                    this.t_name = "默认模板"
                }
                this.temp.forEach(v=>{
                    if (v.t_id==t_id){
                        this.src_img = v.cover_image
                        this.t_name = v.t_name
                    }
                })
            },
            handleUpdatpId(row,t_id){
                let that = this
                if(that.t_id === null){

                    this.$ajax.post('page/Decoration/updateId', {tid:that.t_id}).then(function (res) {
                        if (res.data.error === 0) {
                            that.$message({
                                type: "success",
                                message: " 使用默认模板!"
                            });
                        } else {
                            that.$message(res.data.message)
                        }
                    })
                }else{

                    this.$ajax.post('page/Decoration/updateId', {tid:that.t_id}).then(function (res) {
                        if (res.data.error === 0) {
                            that.$message({
                                type: "success",
                                message: "选择新模板成功"
                            });
                        } else {
                            that.$message(res.data.message)
                        }
                    })
                }

            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },

            //2020/4/14
            binding(i){
              this.binGoods = true
              this.goodNmber = i

            },
            //展示商品id
            goodsId(){
                let that = this
                this.$ajax.post('page/Decoration/goodsBang')
                    .then(function (res) {
                        if (res.data.error === 0) {
                            that.g_id1= res.data.data.g_id1
                            that.g_id2= res.data.data.g_id2
                            that.g_id3= res.data.data.g_id3
                            that.design.g_id = res.data.data.g_id1
                            that.design.b_id = res.data.data.b_id
                        }
                    })
                    .catch(function (err) {
                        that.$message('网络错误！请联系管理员')
                    });
            },
            onGoods(row){
                let that = this;
                this.$ajax
                    .post("/page/Decoration/goodsBannerId", {
                        g_id : row.g_id,
                        num : this.goodNmber
                    })
                    .then(function (res) {
                        if (res.data.error === 0) {
                            that.$message({
                                type: "success",
                                message: "更换成功!"
                            });
                            that.goodsId()
                        }
                    })
                    .catch(function (err) {
                        that.$message("网络错误！请联系管理员");
                        that.loading = false;
                    });

            },
            shopDesign(){
                let that = this
                this.$ajax.post(this.$work_host+'/index.php/admin/login/onShopDesign',this.design)
                    .then(function (res) {
                        if (res.data.error === 0) {
                            that.$message({
                                type: "success",
                                message: "提交成功!"
                            });
                        }
                    })
                    .catch(function (err) {
                        that.$message('网络错误！请联系管理员')
                    });
            },

            onEntry(){
                let that = this
                this.$ajax.post(this.$work_host+'/index.php/admin/login/baiduEntry',{lemma_id:this.baidu_entry,b_id:this.b_id})
                    .then(function (res) {
                        if (res.data.error === 0) {
                            that.$message({
                                type: "success",
                                message: "提交成功!"
                            });
                        }
                    })
                    .catch(function (err) {
                        that.$message('网络错误！请联系管理员')
                    });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/page/decoration/Index.vue